import { render, staticRenderFns } from "./TherapistDashModalUnbook.vue?vue&type=template&id=d6487ea8&scoped=true"
import script from "./TherapistDashModalUnbook.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalUnbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6487ea8",
  null
  
)

export default component.exports